import "./Cart.scss";
import { MdClose } from "react-icons/md";
import { BsCartX } from "react-icons/bs";
import CartItem from "./CartItem/CartItem";
import { useAppContext } from "../../utils/context";
import { useNavigate } from "react-router-dom";
import SimulatedPayment from "./PaymentGateway/SimulatedPayment";

const Cart = ({ setShowCart }) => {
  const { cartSubTotatl, cartItems } = useAppContext();
  const navigate = useNavigate();

  const handleReturnCTA = () => {
    navigate("/");
    setShowCart(false);
  };
  return (
    <div className="cart-panel">
      <div className="opac-layer"></div>
      <div className="cart-content">
        <div className="cart-header">
          <span className="heading">Shopping Cart</span>
          <span className="close-btn" onClick={() => setShowCart(false)}>
            <MdClose />
            <span className="text">close</span>
          </span>
        </div>
        {!cartItems.length && (
          <div className="empty-cart">
            <BsCartX />
            <span>No products in the cart.</span>
            <button className="return-cta" onClick={handleReturnCTA}>
              RETURN TO SHOP
            </button>
          </div>
        )}
        {cartItems.length > 0 && (
          <>
            <CartItem />
            <div className="cart-footer">
              <div className="subtotal">
                <span className="text">Subtotal:</span>
                <span className="text total">
                  &#8377;{cartSubTotatl.toFixed(2)}
                </span>
              </div>
              <div className="button">
                <SimulatedPayment amount={cartSubTotatl.toFixed(2)}/>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Cart;
